import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthStore} from "@/store/useAuth.store";
import ProfilePage from "./ProfilePage";

const ProfileRoute = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);

  useEffect(() => {
    if (authStatus === "unauthenticated") navigate("/", {replace: true});
  }, [authStatus, navigate]);

  if (authStatus !== "authenticated") {
    return <main className="min-h-screen w-full bg-[var(--color-bg)]" />;
  }

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <ProfilePage />
    </main>
  );
};

export default ProfileRoute;
